import 'shared/styles';
import './style.scss';

import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import scrollDir from 'shared/utils/scrolldir';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import Header from '../header';
import Footer from '../footer';
import SideNav from '../sideNav';
import { hideCart } from '../cart/actions';
import { applyAppScroll } from '../app/actions';
import { AsyncCartPreview } from 'components/async';

let AppWrapper = class AppWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.closeCart = this.closeCart.bind(this);
  }

  componentDidMount() {
    this.scrollDir = scrollDir(this, this.header);
    this.cartOpenScrollDir = scrollDir(this, this.header, this.appContainer);
    window.addEventListener('scroll', this.scrollDir, { passive: true });
    AsyncCartPreview.preload();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.cartOpen !== this.props.cartOpen) {
      this.props.applyAppScroll();

      if (this.props.cartOpen) {
        window.removeEventListener('scroll', this.scrollDir);
        this.appContainer.addEventListener('scroll', this.cartOpenScrollDir, {
          passive: true
        });
      } else {
        this.appContainer.removeEventListener('scroll', this.cartOpenScrollDir);
        window.addEventListener('scroll', this.scrollDir, {
          passive: true
        });
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.scrollDir);
  }

  _routePageName() {
    const routes = this.props.routes || [];
    if (!routes.length) return;
    const activeRoute = routes[routes.length - 1];
    return activeRoute && activeRoute.pageName;
  }

  closeCart(e) {
    const isButton = e.target.nodeName === 'BUTTON';
    const isLink = e.target.nodeName === 'A';
    if (this.props.cartOpen && !isButton && !isLink) this.props.hideCart();
  }

  render() {
    const pageName = this._routePageName() || this.props.pageName;
    const appClassName = 'app' + (this.props.cartOpen ? ' app--cart-open' : '');

    return (
      <Fragment>
        <main id="panel" className="panel slideout-panel">
          <Header
            pageName={pageName}
            cartOpen={this.props.cartOpen}
            headerRef={div => (this.header = div)}
          />

          <div
            id="app-container"
            className={appClassName}
            onClick={this.closeCart}
            ref={div => (this.appContainer = div)}
          >
            {this.props.children}
            <Footer />
          </div>

          <TransitionGroup>
            {this.props.cartOpen && (
              <CSSTransition
                key="cart-preview-container"
                classNames="cart-preview-container"
                timeout={300}
              >
                <div className="cart-preview-container">
                  <AsyncCartPreview />
                </div>
              </CSSTransition>
            )}
          </TransitionGroup>
        </main>

        <SideNav />
      </Fragment>
    );
  }
};

AppWrapper = connect(
  state => ({
    cartOpen: state.cart.show
  }),
  { hideCart, applyAppScroll }
)(AppWrapper);

export default AppWrapper;



// WEBPACK FOOTER //
// ./shared/components/app/index.js